import React from 'react';
import TooltipInfo from "Components/Common/components/TooltipInfo"
import { TTableHeaderProps } from "types/Components/Common/Table/Table"
import { conditionalStyle } from "../utils"
import TableHeaderControlModal from "./TableHeaderControlModal"
import { IndeterminateCheckbox } from "Components/Table/Components/IndeterminateCheckbox"
import TableHeaderControlButton from "./TableHeaderControlButton"


/**
 * Common table header with header management option
 * 
 * @param param0 
 * @returns 
 */
export default function TableHeaders ({
    options, 
    headers, 
    setHeaderControlOpen, 
    headerControlOpen, 
    handleSave,
    rows,
    handleSelectAll,
    selectedAllCondition,
    defaultHeaders}: TTableHeaderProps) {

    const selected = !options?.disableheaderSelectAll && selectedAllCondition && selectedAllCondition(rows)

    return (
        <>
            <thead className={`tw-sticky tw-top-0 tw-z-[1001] tw-text-[#6B778C]`}>
                <tr>
            {
                options?.selectable &&
                <th className={`${options?.headerClassName ?? ""} tw-bg-[#DFE0E6]  tw-sticky tw-left-0 tw-h-full`}>
                    <div  style = {{paddingLeft: options?.firstColPaddingLeft ?? 0}} className={`${options?.headerClassName ?? ""} tw-w-12 tw-text-center tw-max-h-min`}>
                    {
                        !options?.disableheaderSelectAll &&
                        <IndeterminateCheckbox checked={selected === 1 && "checked"}  indeterminate={selected === 0}  onChange={(e: React.ChangeEvent<HTMLInputElement>) => handleSelectAll && handleSelectAll(e, rows)}/>
                    }
                    </div>
                </th>
            }
            {
                headers?.filter((header) => header.display).map((header, key) => (
                    <th key={key} className={`${options?.headerClassName ?? ""} tw-bg-[#DFE0E6]`}
                        style={conditionalStyle(header.options)}
                    >
                        <div 
                        style={{width: header.options?.width ?? "auto"}} 
                        className={`tw-py-3 tw-flex tw-space-x-2 tw-items-center tw-px-2 tw-pr-6
                            ${options?.headerClassName ?? ""} 
                            ${header.options?.sticky?.[0] ? "tw-shadow-r" : ""} 
                            ${header.className ?? ""}`}
                        >
                            <h3 className="tw-uppercase">{header.name}</h3>
                            {
                                (!options?.disableSort && header.sortable) && 
                                <i className={`fas fa-sort tw-text-xs`} />
                            }
                            {
                                header.options?.info && 
                                <TooltipInfo message={header.options.info}/>
                            }
                        </div>
                    </th>
                ))
            }
            {
                !options?.disableRowOptions && <th className={`${options?.headerClassName ?? ""} tw-bg-[#DFE0E6] tw-sticky tw-right-0 tw-rel  tw-text-center tw-z-10 `}>
                    <div className={`tw-absolute tw-top-0 tw-right-full tw-h-full tw-bg-gradient-to-r tw-w-[100px] tw-from-transparent tw-pointer-events-none ${options?.headerStickyToClassName ?? "tw-to-[#DFE0E6]"}`}></div>
                    { !options?.accordion && 
                        <TableHeaderControlButton
                            disableHeaderControls={options?.disableHeaderControls}
                            setHeaderControlOpen={setHeaderControlOpen}
                    />
                    }
                </th>
            }
            { 
            options?.accordion && <th className={`${options?.headerClassName ?? ""} tw-bg-[#DFE0E6] tw-sticky tw-right-0 tw-rel tw-text-center tw-z-10 tw-max(40px,100%)`}>
                {
                    !options?.disableHeaderControls && 
                    <TableHeaderControlButton
                        disableHeaderControls={options?.disableHeaderControls}
                        setHeaderControlOpen={setHeaderControlOpen}
                    />
                }
            </th>
            }
            </tr>
        </thead>
        {
            (!options?.disableHeaderControls && headerControlOpen) && 
            <TableHeaderControlModal
                headers={headers}
                handleSave={handleSave}
                defaultHeaders = {defaultHeaders}
                headerControlOpen={headerControlOpen}
                setHeaderControlOpen={setHeaderControlOpen}
            /> 
        }
    </>
    )
}